import React from 'react';
import { RouteComponentProps, Link, withRouter } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'
import { reduxActions, RootState } from '../../store';
import {
    CheckboxVisibility, DetailsHeader, DetailsList, DetailsListLayoutMode, Text,
    IColumn, Icon, IContextualMenuItem, IDetailsColumnFieldProps, IDetailsListStyles, IRenderFunction, ITooltipHostStyles, mergeStyleSets,
    Selection, SelectionMode, TooltipHost, TooltipOverflowMode, ContextualMenu, Panel, ICommandBarItemProps, PanelType, PrimaryButton, DefaultButton,
    IDetailsColumnStyles, CommandBar, IButtonProps, ICommandBarStyles, IDetailsList, IDialogContentProps, IModalProps, DialogType, IModalStyles,
    IIconProps, Dialog, DialogFooter, SearchBox, ISearchBoxStyles
} from '@fluentui/react';
import {
    IAggiornaPrioritaMultiRequest, IChoiceField, IField, ILookupField, IProtocol,
    IVisibilita, IWorkspaceTableState
} from '../../shared/interfaces';
import {
    IProtocolloAreaDiLavoro,
    IVisibilitaDTO,
    ISearchCriteria,
    ISearchPageResult
} from '../../shared/interfacesDTO';

import axios, { CancelTokenSource } from 'axios';
import {
    ProtocolloAreaDiLavoroEF_Priority,
    ProtocolloAreaDiLavoroEF_State,
    Protocol_State,
    Visibility_Type,
    Visibilita_ViewMode,
    Indici_FormMode,
    SearchSortDirection,
} from '../../shared/enums';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import areaDiLavoroService from '../../services/areaDiLavoro.service';
import { toastRef } from '../Layout/Layout';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import { subject, Unsubscribe } from '@casl/ability';
import abilityBuild from '../../shared/CASL/appAbility';
import protocolsService from '../../services/protocols.service';
import Utilities from '../../shared/Utilities/utilities';
import Visibilita from '../Protocols/Visibilita/Visibilita';
import RippleLoader from '../Loader/RippleLoader/RippleLoader';
import TableIconProprietario from '../../sharedComponents/TableIconProprietario';
import TableIconInoltro from '../../sharedComponents/TableIconInoltro';
import TableIconCopiaConoscenza from '../../sharedComponents/TableIconCopiaConoscenza';
import TableIconVisibilita from '../../sharedComponents/TableIconVisibilita';
import { SessionState } from '../../store/session/types';
import fieldsService from '../../services/fields.service';
import searchService from '../../services/search.service';
import SearchPanel from '../../sharedComponents/Panels/SearchPanel';
import SummaryIACallout from '../../sharedComponents/SummaryIACallout';

const addIcon: IIconProps = { iconName: 'Add' };

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    iconFieldHeader: {
        padding: 0,
        fontSize: '16px',
    },
    filtriCommandBar: {
        paddingTop: '20px'
    },
    emptyColumn: {}
});

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const visibilitaDialogStyles: Partial<IModalStyles> = {
    main: {
        '@media(min-width: 480px)': {
            width: '100%',
            maxWidth: 450
        }
    }
}

const visibilitaModalProps: IModalProps = {
    isBlocking: false,
    styles: visibilitaDialogStyles,
    className: "visibilita-dialog-wizard"
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const filtriCommandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' }

}

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}

const iconHeaderStyles: Partial<IDetailsColumnStyles> = {
    root: {
        width: '28px !important',
        padding: 0
    },
    cellTitle: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    }
}
const globalSearchBoxStyles: Partial<ISearchBoxStyles> = {
    root: {
        width: 400,
        'border-color': '#9f9f9f'
    }
};

const areaDiLavoroSearchFields: IField[] = [
    {
        displayName: "Priorità",
        internalName: "Priorita",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: ProtocolloAreaDiLavoroEF_Priority.Bassa, text: 'Bassa' },
            { key: ProtocolloAreaDiLavoroEF_Priority.Media, text: 'Media' },
            { key: ProtocolloAreaDiLavoroEF_Priority.Alta, text: 'Alta' }

        ]
    } as IChoiceField,
    {
        displayName: "Presa in carico",
        internalName: "PresaInCarico",
        sharepointType: "User",
        controlType: "autocompleteUser",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        /// definisco le proprietà del picker per non mostrare il pulsante cerca valore inserito
        basePickerProps: {
            pickerSuggestionsProps: {
                suggestionsHeaderText: 'Suggerimenti',
                noResultsFoundText: 'Nessun risultato trovato',
                loadingText: 'Caricamento',
                showRemoveButtons: false,
                showForceResolve: () => { return false }
            }
        }

    } as ILookupField

];

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    features: state.sessionReducer.features,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
    tuttiIProtocolliViewFields: state.sessionReducer.tuttiIProtocolliViewFields,
    campiRicercaAreaLavoroViewFields: state.sessionReducer.campiRicercaAreaLavoroViewFields,
    serchAiFields: state.sessionReducer.serchAiFields,
    isMobile: state.sessionReducer.isMobile,
    workspaceTableState: state.appNavigationReducer.workspaceTableState,
})
const mapDispatch = {
    setProtocol: (protocol: IProtocolloAreaDiLavoro) => (reduxActions.appNavigationActions.setProtocol(protocol)),
    setWorkspaceTableState: (workspaceTableState: (IWorkspaceTableState)) => (reduxActions.appNavigationActions.setWorkspaceTableState(workspaceTableState)),
    unsetWorkspaceTableState: () => (reduxActions.appNavigationActions.unsetWorkspaceTableState()),
    updateSession: (sessionState: Partial<SessionState>) => (reduxActions.sessionActions.updateSession(sessionState)),
}


const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface AreaDiLavoroProtocolsTableProps {
}

type Props = AreaDiLavoroProtocolsTableProps & RouteComponentProps & PropsFromRedux

export interface AreaDiLavoroProtocolsTableState {
    columns: IColumn[];
    items: (IProtocolloAreaDiLavoro | null)[];
    totalCount: number;
    selectedProtocolsAreaDiLavoro: IProtocolloAreaDiLavoro[];
    selectedProtocolVisibilita: IVisibilita[]

    commandBarItems: ICommandBarItemProps[];
    filtriCommandBarItems: ICommandBarItemProps[];
    filtriCommandBarFarItems: ICommandBarItemProps[];

    isLoadingProtocols: boolean;
    showActionsLoader: boolean

    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

    queryCriteria: ISearchCriteria;
    searchPanelIsOpen: boolean;
    searchFormFields: IField[];
    isLoadingSearchFormFields: boolean;

    summaryIA: string | undefined
    summaryIAisLoading: boolean
    summaryIACalloutIsOpen: boolean;
    summaryIACalloutTargetId: string | undefined

    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogModalProps: IModalProps,
    confirmDialogSubmitFunction: Function


}

class AreaDiLavoroProtocolsTable extends React.Component<Props, AreaDiLavoroProtocolsTableState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    detailsListRef = React.createRef<IDetailsList>();
    cancelTokenSources = {};
    private protocolSelection: Selection;
    private readonly EMPTY_VALUE = "-";
    constructor(props) {
        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection() as IProtocolloAreaDiLavoro[];
                this.setState({
                    selectedProtocolsAreaDiLavoro: selection
                }, () => this.updateCommandBarItems());
            },
        });


        this.state = {
            columns: [],
            items: [],
            totalCount: 0,
            selectedProtocolsAreaDiLavoro: [],
            selectedProtocolVisibilita: [],

            commandBarItems: [],
            filtriCommandBarItems: [],
            filtriCommandBarFarItems: [],

            isLoadingProtocols: true,
            showActionsLoader: false,

            queryCriteria: {
                pageNumber: 1,
                filters: [],
                sorts: []
            },
            searchFormFields: [],
            searchPanelIsOpen: false,
            isLoadingSearchFormFields: false,

            summaryIA: undefined,
            summaryIAisLoading: false,
            summaryIACalloutIsOpen: false,
            summaryIACalloutTargetId: undefined,

            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined,

            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogModalProps: {},
            confirmDialogSubmitFunction: () => { },


        };
    }


    componentDidMount() {

        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems();

            let { history, location, match, arxeiaConfigurations } = this.props;

            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);
            let aooId: number = Number(match.params['aooId']);

            if (aooId && uorId) {
                if (uorId === undefined || abilityBuild.cannot('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {
                    history.push({ pathname: '/notfound' });
                }
                //TODO è corretto IProtocol?
                let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
                if (abilityBuild.cannot('read', subject('IProtocolloAreaDiLavoro', prot))) {
                    this.props.history.push({ pathname: '/unauthorized' });
                }

                let storedColumns: IColumn[] = JSON.parse(localStorage.getItem(`columns_${aooId}_${uorId}`)!);

                if (this.props.workspaceTableState && this.props.workspaceTableState.items && this.props.workspaceTableState.items.length > 0 && this.props.workspaceTableState.uorId === uorId) {
                    this.restoreReduxState(this.props.workspaceTableState);
                }
                else if (storedColumns && storedColumns.length > 0) {
                    this.restoreLocalStorage(storedColumns);
                }
                else if (this.props.tuttiIProtocolliViewFields && arxeiaConfigurations) {
                    let { searchFormFields } = this.state;
                    let columns = this.setColumns();
                    let currentQueryCriteria: ISearchCriteria = {
                        ...this.state.queryCriteria,
                    };
                    let newSearchFormFields: IField[] = this.props.campiRicercaAreaLavoroViewFields
                        ? [...areaDiLavoroSearchFields, ...this.props.campiRicercaAreaLavoroViewFields]
                        : searchFormFields;
                    this.setState({
                        columns,
                        queryCriteria: currentQueryCriteria,
                        searchFormFields: newSearchFormFields
                    }, () => {
                        this.getProtocolliAreaDiLavoro();
                    });
                }

                if (!this.props.campiRicercaAreaLavoroViewFields) {
                    this.getSearchFormFields();
                }

                if (!this.props.serchAiFields) {
                    this.getSearchAiFields();
                }

            }
        });
    }


    componentDidUpdate(oldProps: Props, oldState: AreaDiLavoroProtocolsTableState) {

        if ((this.props.currentAoo && this.props.features && (this.props.currentAoo !== oldProps.currentAoo || this.props.location !== oldProps.location))) {

            let { history } = this.props;

            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            if (uorId === undefined || abilityBuild.cannot('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {
                history.push({ pathname: '/notfound' });
            }
            let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
            if (abilityBuild.cannot('read', subject('IProtocolloAreaDiLavoro', prot))) {
                this.props.history.push({ pathname: '/unauthorized' });
            }


            if (oldProps.currentUor !== this.props.currentUor || oldState.selectedProtocolsAreaDiLavoro !== this.state.selectedProtocolsAreaDiLavoro) {
                this.updateCommandBarItems();
            }
        }
        if (this.props.currentAoo && !oldProps.tuttiIProtocolliViewFields && this.props.tuttiIProtocolliViewFields && this.props.arxeiaConfigurations) {
            let columns = this.setColumns();
            let currentQueryCriteria: ISearchCriteria = {
                ...this.state.queryCriteria,
            };

            this.setState({
                items: [],
                columns,
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolliAreaDiLavoro();
            });
        }

    }

    componentWillUnmount() {
        this.saveReduxState();
        this.unsubscribeFromAbility();

        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }

    onRenderMissingItem = (): null => {
        if (this.state.isLoadingProtocols) {
            return null;
        }

        let currentItems = this.state.items.slice();
        currentItems.pop();

        this.setState({
            items: currentItems
        }, () => {
            this.getProtocolliAreaDiLavoro();
        });

        return null;
    };

    getProtocolliAreaDiLavoro() {
        const { location, match } = this.props;
        let aooId: number = Number(match.params['aooId']);
        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (aooId && uorId) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name] = axios.CancelToken.source();

            this.setState({ isLoadingProtocols: true })
            let { queryCriteria, totalCount } = this.state;

            areaDiLavoroService.getProtocolliAreaDiLavoro(uorId, queryCriteria, this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name].token)
                .then((result: ISearchPageResult<IProtocolloAreaDiLavoro>) => {
                    const pageItems = result.items ?? [];
                    const newTotalCount = result.totalCount ?? totalCount;

                    const currentItems = this.removeNullPlaceholders(this.state.items);

                    const mergedItems: (IProtocolloAreaDiLavoro | null)[] = [...currentItems, ...pageItems];
                    const nextPageNumber = queryCriteria.pageNumber + 1;

                    if (mergedItems.length < (newTotalCount ?? 0)) {
                        mergedItems.push(null);
                    }

                    this.setState(prevState => ({
                        items: mergedItems,
                        totalCount: newTotalCount ?? 0,
                        queryCriteria: {
                            ...prevState.queryCriteria,
                            pageNumber: nextPageNumber
                        },
                        isLoadingProtocols: false
                    }), () => {
                        this.saveReduxState();
                    });

                    delete this.cancelTokenSources[areaDiLavoroService.getProtocolliAreaDiLavoro.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile recuperare i protocolli dell'area di lavoro`,
                            life: 5000
                        });
                    }
                    this.setState({
                        items: [],
                        totalCount: 0,
                        isLoadingProtocols: false
                    }, () => {
                        this.saveReduxState();
                    });
                });
        }
    }

    saveReduxState = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number = Number(parsedQueryString.uorId);

        let startItemIndexInView = this.detailsListRef.current?.getStartItemIndexInView() ?? 0;
        let workspaceTableState: IWorkspaceTableState = {
            columns: [...this.state.columns],
            items: this.state.items && this.state.items.length > 0 ? [...this.state.items] : [],
            totalCount: this.state.totalCount,
            queryCriteria: this.state.queryCriteria,
            startItemIndexInView: startItemIndexInView,
            searchFormFields: [...this.state.searchFormFields],
            uorId
        }
        this.props.setWorkspaceTableState({ ...workspaceTableState });
    }

    restoreReduxState = (workspaceTableState: IWorkspaceTableState) => {

        let { history } = this.props;
        let storedState = { ...workspaceTableState }

        if (history.action === 'POP') {
            this.setState({
                columns: this.remapColumns(storedState.columns!), /// serve rimappare perchè nello storage non si possono inserire i metodi (non sono serializzabili)
                items: storedState.items!,
                totalCount: storedState.totalCount,
                queryCriteria: { ...storedState.queryCriteria },
                searchFormFields: [...storedState.searchFormFields],
                isLoadingProtocols: false,
                showActionsLoader: false

            }, () => {
                setTimeout(() => {
                    this.detailsListRef.current?.focusIndex(storedState.startItemIndexInView ?? 0);
                    this.updateCommandBarItems();
                }, 100);
            })
        }
        else {
            let currentQueryCriteria: ISearchCriteria = {
                ...storedState!.queryCriteria!,
                pageNumber: 1,
            };

            this.setState({
                columns: this.remapColumns(storedState.columns!), /// serve rimappare perchè nello storage non si possono inserire i metodi (non sono serializzabili)
                items: [],
                queryCriteria: currentQueryCriteria,
                searchFormFields: [...storedState.searchFormFields],
                isLoadingProtocols: false,
                showActionsLoader: false

            }, () => {
                setTimeout(() => {
                    this.getProtocolliAreaDiLavoro();
                    this.updateCommandBarItems();
                }, 300);
            })
        }
        if (!storedState.searchFormFields || storedState.searchFormFields.length === 0) {
            this.getSearchFormFields();
        }

    }

    restoreLocalStorage = (storedColumns: IColumn[]) => {
        let column: IColumn | undefined = storedColumns.find((col: IColumn) => col.isSorted);
        if (column) {
            let newIsSortedDescending = column.isSortedDescending;
            let direction = newIsSortedDescending
                ? SearchSortDirection.Descending
                : SearchSortDirection.Ascending;

            let currentQueryCriteria: ISearchCriteria = {
                ...this.state.queryCriteria,
                pageNumber: 1,
                sorts: [{ fieldName: column.key, direction: direction }]
            };

            this.setState({
                isLoadingProtocols: true,
                columns: this.remapColumns(storedColumns),
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolliAreaDiLavoro();
            });
        }
    }

    restoreSelection = () => {
        let { selectedProtocolsAreaDiLavoro } = this.state;
        if (selectedProtocolsAreaDiLavoro) {

            selectedProtocolsAreaDiLavoro.forEach(protocolloAreaDiLavoro => {
                let itemIndex = this.state.items.findIndex(el => el?.protocolId === protocolloAreaDiLavoro?.protocolId);
                this.protocolSelection.setIndexSelected(itemIndex, true, false);
            });
        }
    }

    updateContextMenuDashboard = (ev, protocolloAreaDiLavoro: IProtocolloAreaDiLavoro) => {
        const { location } = this.props
        const menuItems: IContextualMenuItem[] = [];
        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        //let { selectedProtocolsAreaDiLavoro } = this.state;
        //let selectedSingleProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined = selectedProtocolsAreaDiLavoro.length === 1 ? selectedProtocolsAreaDiLavoro[0] : undefined;

        menuItems.push(
            {
                key: 'open',
                text: 'Apri documento',
                iconProps: { iconName: 'Document' },
                onClick: () => {
                    this.navigate(ev, protocolloAreaDiLavoro);
                    this.onHideContextualMenu();
                }
            }
        );
        if (protocolloAreaDiLavoro?.hasAttachments) {
            menuItems.push({
                key: 'downloadDocument',
                text: 'Scarica',
                iconProps: { iconName: 'DownloadDocument' },
                split: true,
                onClick: () => {
                    this.onDownloadProtocolDocumentClick();
                    this.onHideContextualMenu();
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downloadAll',
                            text: 'Scarica tutto',
                            iconProps: { iconName: 'Download' },
                            onClick: () => {
                                this.onDownloadAllButtonClick();
                                this.onHideContextualMenu();
                            }
                        },
                    ],
                }

            });

        }
        else {
            menuItems.push({
                key: 'downloadDocument',
                text: 'Scarica',
                iconProps: { iconName: 'DownloadDocument' },
                onClick: () => {
                    this.onDownloadProtocolDocumentClick();
                    this.onHideContextualMenu();
                }
            });
        }


        // ricavo le uor in cui l'utente corrente ha ruolo Operatore
        const uorIdWhereUserIsOperatore = this.props.currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === this.props.currentAoo?.id && o.ruoloNome === "Operatore" && a.push(o.uorId), a), []) ?? [];

        // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
        // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
        // creare il protocollo
        if (uorIdWhereUserIsOperatore.length > 0) {
            menuItems.push({
                key: 'createFrom',
                text: 'Crea da',
                iconProps: { iconName: 'Copy' },
                onClick: (event) => {
                    let protocolId = protocolloAreaDiLavoro!.protocolId;
                    this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/createfrom/${protocolId}` })
                }


            });
        }
        if (uorIdWhereUserIsOperatore.length > 0 && uorIdWhereUserIsOperatore.some(el => el === uorId)) {
            menuItems.push(
                {
                    key: 'editVisibilita',
                    text: 'Modifica visibilità',
                    iconProps: { iconName: 'RedEye' },
                    onClick: () => this.onEditVisibilitaHandler()
                },
            );
        }
        if (protocolloAreaDiLavoro!.statoLavorazione === ProtocolloAreaDiLavoroEF_State.Undefined
            || protocolloAreaDiLavoro!.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere) {
            menuItems.push(
                {
                    key: 'avviaLavorazione',
                    text: 'Avvia lavorazione',
                    iconProps: { iconName: 'Play' },
                    onClick: this.onAvviaLavorzioneClick
                },
            );

        }
        if (protocolloAreaDiLavoro!.statoLavorazione === ProtocolloAreaDiLavoroEF_State.InLavorazione) {
            menuItems.push(
                {
                    key: 'priorita',
                    text: 'Priorit\u00e0',
                    iconProps: { iconName: 'Sort' },
                    subMenuProps: {
                        items: [
                            {
                                key: 'alta',
                                text: 'Alta',
                                iconProps: { iconName: 'ChevronUp' },
                                onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Alta)
                            },
                            {
                                key: 'media',
                                text: 'Media',
                                iconProps: { iconName: 'Remove' },
                                onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Media)
                            },
                            {
                                key: 'bassa',
                                text: 'Bassa',
                                iconProps: { iconName: 'ChevronDown' },
                                onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Bassa)
                            },
                        ],
                    },
                },
            );
            menuItems.push(
                {
                    key: 'presaInCarico',
                    text: 'Presa in carico',
                    iconProps: { iconName: 'ReminderPerson' },
                    onClick: this.onPresaInCaricoClick
                },
            );
            menuItems.push(
                {
                    key: 'terminaLavorzione',
                    text: 'Termina lavorazione',
                    iconProps: { iconName: 'CheckList' },
                    onClick: this.onTerminaLavorzioneClick
                },
            );

        }

        return menuItems;
    }

    updateCommandBarItems = () => {
        const { currentUor, currentUser, currentAoo, location } = this.props
        const newCommandBarItems: ICommandBarItemProps[] = [];
        const newFiltriCommandBarItems: ICommandBarItemProps[] = [];
        const newFiltriCommandBarFarItems: ICommandBarItemProps[] = [];
        newFiltriCommandBarFarItems.push(
            {
                key: 'globalSearchBox',
                commandBarButtonAs: () => (

                    <SearchBox
                        placeholder="Ricerca"
                        styles={globalSearchBoxStyles}
                        onSearch={searchValue => this.globalSearchSubmitHandler(searchValue)}
                        defaultValue={this.state.queryCriteria?.globalSearch} />

                )
            }
        );

        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        let prot: Partial<IProtocol> = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };

        if (abilityBuild.can('create', subject('IProtocol', prot))) {
            newCommandBarItems.push(
                {
                    key: 'nuovoProtocollo',
                    commandBarButtonAs: () => (
                        <DefaultButton
                            primary
                            text="Nuovo"
                            iconProps={addIcon}
                            allowDisabledFocus
                            onClick={(event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/new` })}

                        />
                    )
                }

            );

        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'PecMail', enabled: true }))
            && abilityBuild.can('read', 'IMailPecMail')
            && currentUor && currentUor.mailboxesIn && currentUor.mailboxesIn.length > 0) {

            newCommandBarItems.push({
                key: 'pecmail',
                text: 'Pec & Mail',
                iconProps: { iconName: 'Mail' },
                onClick: (event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/pecmail` })


            });
        }



        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('read', 'IFascicolo')
            && currentUor) {

            newCommandBarItems.push({
                key: 'fascicoli',
                text: 'Fascicoli',
                iconProps: { iconName: 'DocumentSet' },
                onClick: (event) => this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/fascicoli` })

            });
        }

        let { selectedProtocolsAreaDiLavoro } = this.state;
        let selectedSingleProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined = selectedProtocolsAreaDiLavoro.length === 1 ? selectedProtocolsAreaDiLavoro[0] : undefined;
        if (selectedSingleProtocolAreaDiLavoro) {
            if (selectedSingleProtocolAreaDiLavoro.hasAttachments) {
                newCommandBarItems.push({
                    key: 'downloadDocument',
                    text: 'Scarica',
                    iconProps: { iconName: 'DownloadDocument' },
                    split: true,
                    onClick: this.onDownloadProtocolDocumentClick,
                    subMenuProps: {
                        items: [
                            {
                                key: 'downloadAll',
                                text: 'Scarica tutto',
                                iconProps: { iconName: 'Download' },
                                onClick: this.onDownloadAllButtonClick
                            },
                        ],
                    }

                });

            }
            else {
                newCommandBarItems.push({
                    key: 'downloadDocument',
                    text: 'Scarica',
                    iconProps: { iconName: 'DownloadDocument' },
                    onClick: this.onDownloadProtocolDocumentClick
                });
            }


            // ricavo le uor in cui l'utente corrente ha ruolo Operatore
            const uorIdWhereUserIsOperatore = currentUser?.ruoliUorContext.reduce((a: number[], o) => (o.aooId === currentAoo?.id && o.ruoloNome === "Operatore" && a.push(o.uorId), a), []) ?? [];

            // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
            // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
            // creare il protocollo

            if (uorIdWhereUserIsOperatore.length > 0) {
                newCommandBarItems.push({
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: (event) => {
                        let protocolId = selectedSingleProtocolAreaDiLavoro!.protocolId;
                        this.commandBarNavigateItemHandler(event, { url: `/${this.props.currentAoo?.id}/createfrom/${protocolId}` })
                    }
                });
            }

            if (uorIdWhereUserIsOperatore.length > 0 && uorIdWhereUserIsOperatore.some(el => el === uorId)) {
                newCommandBarItems.push({
                    key: 'editVisibilita',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Modifica visibilità'
                            key='editVisibilita'
                            iconPropsFontAwesome={{ icon: ['fal', 'eye'] }}
                            onClick={this.onEditVisibilitaHandler}
                        />
                    )
                });
            }
        }
        if (selectedProtocolsAreaDiLavoro.length > 0) {

            if ((selectedProtocolsAreaDiLavoro.some(el => el != null && el.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere))) {
                newCommandBarItems.push(
                    {
                        key: 'avviaLavorazione',
                        text: 'Avvia lavorazione',
                        iconProps: { iconName: 'Play' },
                        onClick: this.onAvviaLavorzioneClick
                    },
                );
            }

            if (!selectedProtocolsAreaDiLavoro.some(el => el != null && el.statoLavorazione !== ProtocolloAreaDiLavoroEF_State.InLavorazione)) {
                newCommandBarItems.push(
                    {
                        key: 'priorita',
                        text: 'Priorit\u00e0',
                        iconProps: { iconName: 'Sort' },
                        subMenuProps: {
                            items: [
                                {
                                    key: 'alta',
                                    text: 'Alta',
                                    iconProps: { iconName: 'ChevronUp' },
                                    onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Alta)
                                },
                                {
                                    key: 'media',
                                    text: 'Media',
                                    iconProps: { iconName: 'Remove' },
                                    onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Media)
                                },
                                {
                                    key: 'bassa',
                                    text: 'Bassa',
                                    iconProps: { iconName: 'ChevronDown' },
                                    onClick: () => this.onSelectedPriorityChange(ProtocolloAreaDiLavoroEF_Priority.Bassa)
                                },
                            ],
                        },
                    },
                );
                newCommandBarItems.push(
                    {
                        key: 'presaInCarico',
                        text: 'Presa in carico',
                        iconProps: { iconName: 'ReminderPerson' },
                        onClick: this.onPresaInCaricoClick
                    },
                );
                newCommandBarItems.push(
                    {
                        key: 'terminaLavorzione',
                        text: 'Termina lavorazione',
                        iconProps: { iconName: 'CheckList' },
                        onClick: this.onTerminaLavorzioneClick
                    },
                );

            }

        }

        newFiltriCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.onFiltriClick}
                    />

                )
            }
        );

        if (this.state.queryCriteria.globalSearch || this.state.queryCriteria.filters.length > 0) {
            newFiltriCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
        }

        newFiltriCommandBarItems.push(
            {
                key: 'aggiornaAreaDiLavoro',
                text: 'Aggiorna',
                iconProps: { iconName: 'Refresh' },
                onClick: this.onAggiornaAreaDiLavoroClick
            },
        );


        this.setState({
            commandBarItems: newCommandBarItems,
            filtriCommandBarItems: newFiltriCommandBarItems,
            filtriCommandBarFarItems: newFiltriCommandBarFarItems
        });
    }

    commandBarNavigateItemHandler = (ev: any, item: any) => {
        ev.preventDefault();

        if (item != null && item.url != null) {
            this.props.history.push({
                pathname: item.url,
                search: this.props.location.search,
            });
        }
    };

    onDownloadProtocolDocumentClick = () => {
        let { currentAoo, location } = this.props;
        const parsedQueryString = queryString.parse(location.search);
        if (currentAoo && this.state.selectedProtocolsAreaDiLavoro) {
            let { selectedProtocolsAreaDiLavoro } = this.state;
            let selectedSingleProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined = selectedProtocolsAreaDiLavoro.length === 1 ? selectedProtocolsAreaDiLavoro[0] : undefined;

            if (selectedSingleProtocolAreaDiLavoro) {
                let protocolId = selectedSingleProtocolAreaDiLavoro.protocolId!;
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                // se in cancelTokenSources c'è il cancelToken associato alla chiamata
                // chiamo il metodo cancel che interrompe la chiamata in pending
                this.cancelTokenSources[protocolsService.getProtocolDocumentFile.name]?.cancel(protocolsService.getProtocolDocumentFile.name + " Request annullata");
                // Ricreo il cancel token ad ogni request
                this.cancelTokenSources[protocolsService.getProtocolDocumentFile.name] = axios.CancelToken.source();

                toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download del documento`, life: 5000 });

                protocolsService
                    .getProtocolDocumentFile(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolDocumentFile.name].token)
                    .then(documentFile => {
                        const saveResult = Utilities.SaveFile(documentFile);

                        if (saveResult.ok) {
                            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download del documento completato con successo`, life: 5000 });
                        } else {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download del documento`, life: 5000 });
                            console.error("Download", "SaveFile result:", saveResult);
                        }
                    })
                    .catch(error => {

                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        } else if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download del documento`, life: 5000 });

                        } else {
                            throw error;
                        }

                    });
            };
        };
    }
    onDownloadAllButtonClick = () => {
        let { currentAoo, location } = this.props;
        const parsedQueryString = queryString.parse(location.search);
        if (currentAoo && this.state.selectedProtocolsAreaDiLavoro) {
            let { selectedProtocolsAreaDiLavoro } = this.state;
            let selectedSingleProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined = selectedProtocolsAreaDiLavoro.length === 1 ? selectedProtocolsAreaDiLavoro[0] : undefined;

            if (selectedSingleProtocolAreaDiLavoro) {
                let protocolId = selectedSingleProtocolAreaDiLavoro.protocolId!;
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                // se in cancelTokenSources c'è il cancelToken associato alla chiamata
                // chiamo il metodo cancel che interrompe la chiamata in pending
                this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name]?.cancel(protocolsService.getProtocolFilesAsZip.name + " Request annullata");
                // Ricreo il cancel token ad ogni request
                this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name] = axios.CancelToken.source();

                toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download degli allegati`, life: 5000 });

                protocolsService
                    .getProtocolFilesAsZip(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name].token)
                    .then(zipFile => {
                        const saveResult = Utilities.SaveFile(zipFile, zipFile?.fileName);

                        if (saveResult.ok) {
                            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download degli allegati completato con successo`, life: 5000 });
                        } else {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });
                            console.error("Download", "SaveFile result:", saveResult);
                        }
                    })
                    .catch(error => {

                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        } else if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });

                        } else {
                            throw error;
                        }

                    });
            };
        };
    }

    // Click sul button della commandbar
    onPresaInCaricoClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogModalProps: {},
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi prendere in carico la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onPresaInCaricoConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onPresaInCaricoConfirmDialogSubmit = () => {
        let { selectedProtocolsAreaDiLavoro } = this.state;
        if (selectedProtocolsAreaDiLavoro.length > 0) {
            let { location } = this.props
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            this.setState({
                confirmDialogIsOpen: false,
                showActionsLoader: true,
            });


            let idItemsAreaDiLavoro = selectedProtocolsAreaDiLavoro.filter(el => el != null).map(el => el.areaDiLavoroId);
            areaDiLavoroService.pendiInCaricoMulti(uorId, idItemsAreaDiLavoro)
                .then(() => {


                    let { items } = this.state;

                    let currentItems = items.slice();

                    idItemsAreaDiLavoro.forEach(areaDiLavoroId => {
                        let itemIndex = currentItems.findIndex(el => el?.areaDiLavoroId === areaDiLavoroId);
                        let selectedItem: IProtocolloAreaDiLavoro | undefined = currentItems[itemIndex] ?? undefined;
                        if (selectedItem) {
                            selectedItem.presaInCarico = this.props.currentUser!.displayName;
                            currentItems[itemIndex] = { ...selectedItem };
                        }
                    });

                    this.setState({
                        items: currentItems,
                        showActionsLoader: false,
                    }, () => {
                        this.saveReduxState();
                        this.restoreSelection();

                    });

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });
        }
    }

    // Click sul button della commandbar
    onAvviaLavorzioneClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogModalProps: {},
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi avviare la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onAvviaLavorazioneEPendiInCaricoConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onAvviaLavorazioneEPendiInCaricoConfirmDialogSubmit = () => {
        let { selectedProtocolsAreaDiLavoro } = this.state;
        if (selectedProtocolsAreaDiLavoro.length > 0) {
            let { location } = this.props
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            this.setState({
                confirmDialogIsOpen: false,
                showActionsLoader: true,
            });


            let idItemsAreaDiLavoro = selectedProtocolsAreaDiLavoro.filter(el => el != null).map(el => el.areaDiLavoroId);
            areaDiLavoroService.avviaLavorazioneEPrendiInCaricoMulti(uorId, idItemsAreaDiLavoro)
                .then(() => {

                    let { items } = this.state;

                    let currentItems = items.slice();

                    idItemsAreaDiLavoro.forEach(areaDiLavoroId => {
                        let itemIndex = currentItems.findIndex(el => el?.areaDiLavoroId === areaDiLavoroId);
                        let selectedItem: IProtocolloAreaDiLavoro | undefined = currentItems[itemIndex] ?? undefined;
                        if (selectedItem) {
                            selectedItem.presaInCarico = this.props.currentUser!.displayName;
                            selectedItem.statoLavorazione = ProtocolloAreaDiLavoroEF_State.InLavorazione;
                            currentItems[itemIndex] = { ...selectedItem };
                        }
                    });


                    this.setState({
                        items: currentItems,
                        showActionsLoader: false,
                    }, () => {
                        this.saveReduxState();
                        this.restoreSelection();
                    });


                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

        }
    }

    avviaLavorzione = () => {
        let { selectedProtocolsAreaDiLavoro } = this.state
        if (selectedProtocolsAreaDiLavoro && selectedProtocolsAreaDiLavoro.length === 1) {
            let { location } = this.props
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            let selectedProtocol = selectedProtocolsAreaDiLavoro[0];
            areaDiLavoroService.avviaLavorazione(uorId, selectedProtocol.areaDiLavoroId)
                .then(() => {

                    let { items } = this.state;

                    let currentItems = items.slice();
                    let itemIndex = currentItems.findIndex(el => el?.areaDiLavoroId === selectedProtocolsAreaDiLavoro[0].areaDiLavoroId);
                    let selectedItem: IProtocolloAreaDiLavoro | undefined = currentItems[itemIndex] ?? undefined;
                    if (selectedItem) {
                        selectedItem.statoLavorazione = ProtocolloAreaDiLavoroEF_State.InLavorazione;
                        currentItems[itemIndex] = { ...selectedItem };
                    }

                    this.setState({
                        items: currentItems,
                        showActionsLoader: false,
                    }, () => {
                        this.saveReduxState();
                        this.restoreSelection();
                    });

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento area di lavoro non riuscito`, life: 5000 });
                    }
                });

        }
    }


    onSelectedPriorityChange = (selectedPriority: ProtocolloAreaDiLavoroEF_Priority) => {
        let { selectedProtocolsAreaDiLavoro } = this.state;
        if (selectedProtocolsAreaDiLavoro.length > 0) {
            let { location } = this.props
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            this.setState({
                showActionsLoader: true,
            });

            let idItemsAreaDiLavoro = selectedProtocolsAreaDiLavoro.filter(el => el != null).map(el => el.areaDiLavoroId);

            let request: IAggiornaPrioritaMultiRequest = {
                idItemsAreaDiLavoro,
                priorita: selectedPriority
            }
            areaDiLavoroService.aggiornaPrioritaMulti(uorId, request)
                .then(() => {

                    let { items } = this.state;

                    let currentItems = items.slice();

                    idItemsAreaDiLavoro.forEach(areaDiLavoroId => {
                        let itemIndex = currentItems.findIndex(el => el?.areaDiLavoroId === areaDiLavoroId);
                        let selectedItem: IProtocolloAreaDiLavoro | undefined = currentItems[itemIndex] ?? undefined;
                        if (selectedItem) {
                            selectedItem.priorita = selectedPriority;
                            currentItems[itemIndex] = { ...selectedItem };
                        }
                    });

                    this.setState({
                        items: currentItems,
                        showActionsLoader: false,
                    }, () => {
                        this.saveReduxState();
                        this.restoreSelection();
                    });

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });
        }
    }

    // Click sul button della commandbar
    onTerminaLavorzioneClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogModalProps: {},
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi terminare la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onTerminaLavorzioneConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onTerminaLavorzioneConfirmDialogSubmit = () => {
        let { selectedProtocolsAreaDiLavoro } = this.state;
        if (selectedProtocolsAreaDiLavoro.length > 0) {
            let { location } = this.props
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            this.setState({
                confirmDialogIsOpen: false,
                showActionsLoader: true,
            });

            let idItemsAreaDiLavoro = selectedProtocolsAreaDiLavoro.filter(el => el != null).map(el => el.areaDiLavoroId);
            areaDiLavoroService.terminaLavorazioneMulti(uorId, idItemsAreaDiLavoro)
                .then(() => {

                    let { items } = this.state;

                    let currentItems = items.slice();

                    idItemsAreaDiLavoro.forEach(areaDiLavoroId => {
                        let itemIndex = currentItems.findIndex(el => el?.areaDiLavoroId === areaDiLavoroId);
                        currentItems.splice(itemIndex, 1);
                    });
                    this.protocolSelection.setAllSelected(false);

                    this.setState({
                        items: currentItems,
                        showActionsLoader: false,
                        selectedProtocolsAreaDiLavoro: []
                    }, () => {
                        this.saveReduxState();
                    });

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

        }
    }


    onEditVisibilitaHandler = () => {

        if (this.props.currentAoo && this.state.selectedProtocolsAreaDiLavoro) {
            let { currentAoo } = this.props;
            let { selectedProtocolsAreaDiLavoro } = this.state;
            let selectedSingleProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined = selectedProtocolsAreaDiLavoro.length === 1 ? selectedProtocolsAreaDiLavoro[0] : undefined;
            if (selectedSingleProtocolAreaDiLavoro) {

                this.setState({
                    confirmDialogIsOpen: true,
                    confirmDialogModalProps: visibilitaModalProps,
                    confirmDialogContentProps: {
                        type: DialogType.largeHeader,
                        title: 'Visibilità',
                        children:
                            <div style={{ overflow: "hidden", height: "100%", minHeight: "100px" }}>
                                <CircleLoader loaderClass='loader-large' loading={true} />
                            </div>
                    }
                })

                protocolsService.getVisibilitaProtocollo(currentAoo.id, selectedSingleProtocolAreaDiLavoro!.protocolId!)
                    .then(async result => {

                        let visibilita = [...result];

                        this.setState({
                            confirmDialogContentProps: {
                                type: DialogType.largeHeader,
                                title: 'Visibilità',
                                subText: 'Scegli la visibilità.',
                                children:
                                    <div style={{ overflow: "hidden", height: "100%", minHeight: "100px" }}>
                                        <Visibilita
                                            visibilita={visibilita}
                                            onUpdateVisibilitaHandler={
                                                (_visibilita) => {
                                                    this.setState({ selectedProtocolVisibilita: _visibilita });
                                                }
                                            }
                                            viewMode={Visibilita_ViewMode.Expanded}
                                        />
                                    </div>
                            },
                            confirmDialogSubmitFunction: () => { this.submitEditVisibilitaDialog() },
                            selectedProtocolVisibilita: visibilita
                        })

                    });
            };
        }
    }

    // Click su conferma del confirm dialog
    submitEditVisibilitaDialog = () => {
        if (this.props.currentAoo && this.props.currentUor && this.state.selectedProtocolsAreaDiLavoro) {
            let { currentAoo, currentUor, location } = this.props
            let { selectedProtocolsAreaDiLavoro, selectedProtocolVisibilita, items } = this.state;
            let selectedSingleProtocolAreaDiLavoro: IProtocolloAreaDiLavoro | undefined = selectedProtocolsAreaDiLavoro.length === 1 ? selectedProtocolsAreaDiLavoro[0] : undefined;

            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            this.setState({ confirmDialogIsOpen: false, showActionsLoader: true });

            let visibilitaDTO: IVisibilitaDTO[] = selectedProtocolVisibilita!.map(el => {
                return { entityId: el.uor.id!, accessType: el.tipologia }
            })
            if (selectedSingleProtocolAreaDiLavoro) {

                protocolsService.updateVisibilitaProtocol(currentAoo.id, uorId, selectedSingleProtocolAreaDiLavoro.protocolId!, visibilitaDTO)
                    .then(result => {
                        let selectedItem: IProtocolloAreaDiLavoro | undefined = { ...selectedSingleProtocolAreaDiLavoro! };
                        let currentItems = items.slice();
                        let itemIndex = currentItems.findIndex(el => el?.protocolId === selectedSingleProtocolAreaDiLavoro!.protocolId);
                        let removeItem = selectedProtocolVisibilita.some(el => el.uor.id === currentUor.id && el.tipologia !== Visibility_Type.Visibilita) ? false : true;
                        if (removeItem) {
                            currentItems.splice(itemIndex, 1);
                            selectedItem = undefined;
                        }
                        else {
                            selectedItem!.visibilita = [...selectedProtocolVisibilita];
                            currentItems[itemIndex] = { ...selectedItem };
                        }
                        this.setState({
                            items: currentItems,
                            showActionsLoader: false,
                            selectedProtocolsAreaDiLavoro: selectedItem ? [{ ...selectedItem }] : [],
                        }, () => {
                            this.saveReduxState();
                        });

                        toastRef.current?.show({ severity: 'info', summary: 'Aggiornamento', detail: `Visibilità aggiornata correttamente`, life: 5000 });
                    })
                    .catch(error => {
                        this.setState({ showActionsLoader: false });
                        if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Visibilità non aggiornata`, life: 5000 });
                        }
                    });
            };
        }
    }

    onFiltriClick = () => {
        this.setState({ searchPanelIsOpen: true });
        if (!this.state.searchFormFields || this.state.searchFormFields.length === 0) {
            this.getSearchFormFields();
        }

    }

    // Click su cerca del panel laterale
    submitSearchPanelHandler = (newSearchFormFields: IField[]) => {
        let { queryCriteria } = this.state;

        let touchedFields: IField[] = newSearchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsValueForSearchEFSubmit([...touchedFields]);

        let currentQueryCriteria: ISearchCriteria = {
            ...queryCriteria,
            pageNumber: 1,
            filters: [...fixedFields],
            globalSearch: undefined
        };

        this.setState({
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            searchFormFields: [...newSearchFormFields],
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.saveReduxState();
            this.getProtocolliAreaDiLavoro();
            this.updateCommandBarItems();
        });
    }

    globalSearchSubmitHandler = (searchValue) => {
        if (searchValue.trim().length >= 3) {
            let { searchFormFields, queryCriteria } = this.state;

            let newSearchFields = searchFormFields.map(el => {
                return { ...el, internalValue: null, touched: false };
            });

            let currentQueryCriteria: ISearchCriteria = {
                ...queryCriteria,
                pageNumber: 1,
                filters: [],
                globalSearch: searchValue
            };

            this.setState({
                searchFormFields: newSearchFields,
                isLoadingProtocols: true,
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.saveReduxState();
                this.getProtocolliAreaDiLavoro();
                this.updateCommandBarItems();
            });
        }
        else {
            toastRef.current?.show({
                severity: 'warn',
                summary: 'Attenzione',
                detail: `Inserire almeno 3 caratteri per avviare la ricerca`,
                life: 3000
            });
        }
    }

    onAggiornaAreaDiLavoroClick = () => {
        let { queryCriteria } = this.state;

        let currentQueryCriteria: ISearchCriteria = {
            ...queryCriteria,
            pageNumber: 1
        };

        this.setState({
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolliAreaDiLavoro();
            this.updateCommandBarItems();
        });
    }

    //metodo per resettare la ricerca
    resetSearchHandler = () => {
        let { searchFormFields, queryCriteria } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });

        let currentQueryCriteria: ISearchCriteria = {
            ...queryCriteria,
            pageNumber: 1,
            filters: [],
            globalSearch: undefined
        };

        this.protocolSelection.setAllSelected(false);

        this.setState({
            searchFormFields: newSearchFields,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.saveReduxState();
            this.getProtocolliAreaDiLavoro();
            this.updateCommandBarItems();
        });
    }

    //metodo per resettare la form di ricerca
    resetSearchFieldsHandler = () => {
        let { searchFormFields } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields
        }, () => {
            this.saveReduxState()
        });
    }

    formSearchInputChangedHandler = (newField: IField) => {
        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        }, () => {
            this.saveReduxState()
        });

    }

    // metodi gestione context menu 
    onShowContextualMenu = (item: IProtocolloAreaDiLavoro, index, ev) => {
        ev.preventDefault();

        const menuItems = this.updateContextMenuDashboard(ev, item);
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    checkUor() {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (uorId) {
            return true;
        }
        else if (this.props.currentAoo) {

            this.props.history.push({ pathname: `/${this.props.currentAoo.id}/ricerca` });
            return false;

        }
        else {

            return false;

        }
    }

    remapColumns = (columns: IColumn[]): IColumn[] => {
        columns = columns.map(el => {
            switch (el.key) {
                case 'visibilita':
                    return { ...el, onRenderField: this.onRenderVisibilitaField };
                case 'hasAttachments':
                    return {
                        ...el,
                        onRenderField: this.onRenderAttachmentField,
                        onRenderHeader: () => {
                            return <Icon iconName="Attach" className={classNames.iconFieldHeader} />;
                        }
                    };
                case 'annotazione':
                    return {
                        ...el,
                        onRenderField: this.onRenderAnnotazioneField,
                        onRenderHeader: () => {
                            return <Icon iconName="Message" className={classNames.fileIconHeaderIcon} />;
                        }
                    };
                case 'hasSummaryIAIcon':
                    return {
                        ...el,
                        onRenderField: this.onRenderHasSummaryIAField,
                        onRenderHeader: () => {
                            return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'microchip-ai' }} className={classNames.fileIconHeaderIcon} />
                        }
                    };
                default:
                    return { ...el };
            }

        });
        return columns;
    }

    setColumns = (): IColumn[] => {
        let fields: IField[] = [...this.props.tuttiIProtocolliViewFields!];

        let _fields = fields.filter(f => !f.system
            && f.internalName !== 'ID'
            && f.internalName !== 'Title'
            && f.internalName !== 'Protocollo'
            && f.internalName !== 'Proprietario'
            && f.internalName !== 'CopiaConoscenza'
            && f.internalName !== 'Inoltro'
            && f.internalName !== 'Visibilita');

        let newColumns: IColumn[] = [
            {
                key: 'visibilita',
                name: 'visibilita',
                fieldName: 'visibilita',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 6,
                maxWidth: 6,
                onRenderField: this.onRenderVisibilitaField,
            },
            {
                key: 'hasAttachments',
                name: 'hasAttachments',
                fieldName: 'hasAttachments',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAttachmentField,
                onRenderHeader: () => {
                    return <Icon iconName="Attach" className={classNames.iconFieldHeader} />
                },

            },
            {
                key: 'annotazione',
                name: 'annotazione',
                fieldName: 'annotazione',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAnnotazioneField,
                onRenderHeader: () => {
                    return <Icon iconName="Message" className={classNames.fileIconHeaderIcon} />
                }
            }
        ];
        if (abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true }))) {
            newColumns.push({
                key: 'hasSummaryIAIcon',
                name: 'hasSummaryIAIcon',
                fieldName: 'hasSummaryIAIcon',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 9,
                maxWidth: 9,
                onRenderField: this.onRenderHasSummaryIAField,
                onRenderHeader: () => {
                    return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'microchip-ai' }} className={classNames.fileIconHeaderIcon} />
                }
            })
        }
        newColumns.push(...[
            {
                key: 'Protocollo',
                name: 'Protocollo',
                fieldName: 'Protocollo',
                minWidth: 110,
                maxWidth: 110,
                isResizable: true,
            },

            {
                key: 'Priorita',
                name: 'Priorità',
                fieldName: 'Priorita',
                minWidth: 90,
                maxWidth: 90,
                isResizable: true,
            },
            {
                key: 'PresaInCarico',
                name: 'Presa in carico',
                fieldName: 'PresaInCarico',
                minWidth: 110,
                maxWidth: 120,
                isResizable: true,
            }
        ]);
        _fields.forEach(el => {
            const fieldFullProperties = this.props.tuttiIProtocolliViewFields?.find(it => it.internalName === el.internalName);
            const field = fieldFullProperties ? { ...fieldFullProperties } : { ...el };
            let col: IColumn = {
                key: field.internalName,
                fieldName: field.internalName,
                name: field.displayName,
                minWidth: 150,
                isResizable: true,
                ...field
            };
            if (field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                col.maxWidth = 110;
                col.minWidth = 110;
            } else if (field.internalName === "TipoProtocollo") {
                col.maxWidth = 140;
                col.minWidth = 140;
            }
            newColumns.push(col);
        });
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
        /// l'header e i contenuti della tabella 
        if (!this.props.isMobile) {
            newColumns.push(
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },

            );
        }
        this.saveReduxState();
        return newColumns;
    }


    navigate = (ev, item?: IProtocolloAreaDiLavoro) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.protocolId) {
            this.props.setProtocol(item!);
            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;
            let path;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    path = `/${this.props.currentAoo!.id}/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    path = `/${this.props.currentAoo!.id}/allocated/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    path = `/${this.props.currentAoo!.id}/edit/${item.protocolId}`;
                    break;

            }
            this.props.history.push({ pathname: path, search: this.props.location.search });
        }
    }

    getSearchFormFields = () => {
        this.setState({ isLoadingSearchFormFields: true });
        let { match } = this.props;
        let aooId: number = Number(match.params['aooId']);

        // se in cancelTokenSources c'è il cancelToken associato alla chiamata
        // chiamo il metodo cancel che interrompe la chiamata in pending
        this.cancelTokenSources[fieldsService.getFieldsByViewName.name]?.cancel("Request annullata");
        // Ricreo il cancel token ad ogni request
        this.cancelTokenSources[fieldsService.getFieldsByViewName.name] = axios.CancelToken.source();

        fieldsService
            .getFieldsByViewName(aooId, "Campi ricerca", this.cancelTokenSources[fieldsService.getFieldsByViewName.name].token)
            .then(fields => {
                let fixedFields = AppUtilities.fixFieldsForm(Indici_FormMode.SearchAreaLavoro, fields);

                this.setState({
                    isLoadingSearchFormFields: false,
                    searchFormFields: [...areaDiLavoroSearchFields, ...fixedFields]
                }, () => {
                    this.saveReduxState();
                });
                this.props.updateSession({ campiRicercaAreaLavoroViewFields: fixedFields });

            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else {
                    throw error;
                }
                this.setState({ isLoadingSearchFormFields: false });

            });
        ;
    }

    getSearchAiFields = () => {

        // se in cancelTokenSources c'è il cancelToken associato alla chiamata
        // chiamo il metodo cancel che interrompe la chiamata in pending
        this.cancelTokenSources[searchService.getSearchAiFields.name]?.cancel("Request annullata");
        // Ricreo il cancel token ad ogni request
        this.cancelTokenSources[searchService.getSearchAiFields.name] = axios.CancelToken.source();

        searchService
            .getSearchAiFields(this.cancelTokenSources[searchService.getSearchAiFields.name].token)
            .then(fields => {
                this.props.updateSession({ serchAiFields: fields });
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else {
                    throw error;
                }
            });
        ;
    }



    onClickProtocol = (ev, protocolloAreaDiLavoro: IProtocolloAreaDiLavoro) => {
        this.avviaLavorzione();
        this.navigate(ev, protocolloAreaDiLavoro);
    }

    onColumnHeaderClick = (ev: React.MouseEvent<HTMLElement> | undefined, column: IColumn | undefined): void => {
        ev?.preventDefault();
        ev?.stopPropagation();

        const { columns, queryCriteria } = this.state;
        let { location, match, serchAiFields } = this.props;

        const parsedQueryString = queryString.parse(location.search);
        let uorId: number = Number(parsedQueryString.uorId);
        let aooId: number = Number(match.params['aooId']);

        if (column && (
            column.key === 'Protocollo' ||
            (serchAiFields && serchAiFields.some(el => el.isSortable && (el.name === column.key || el.name === "V_" + column.key)))
        )) {
            let newIsSortedDescending = !column.isSortedDescending;

            let newColumns = columns.map((col: IColumn) => {
                if (col.key === column.key) {
                    col.isSortedDescending = newIsSortedDescending;
                    col.isSorted = true;
                } else {
                    col.isSorted = false;
                    col.isSortedDescending = true;
                }
                return col;
            });

            let direction = newIsSortedDescending
                ? SearchSortDirection.Descending
                : SearchSortDirection.Ascending;

            let currentQueryCriteria: ISearchCriteria = {
                ...queryCriteria,
                pageNumber: 1,
                sorts: [{ fieldName: column.key, direction: direction }]
            };

            this.setState({
                isLoadingProtocols: true,
                columns: newColumns,
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolliAreaDiLavoro();
                localStorage.setItem(`columns_${aooId}_${uorId}`, JSON.stringify(newColumns));
            });
        }
    }

    onRenderAttachmentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasAttachments) {
            iconContent = (
                <Icon iconName="Attach" style={{ fontSize: 16 }} />
            );

        }

        return (
            <div key={`attachment-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Allegato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderAnnotazioneField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasNotes) {
            iconContent = (
                <Icon iconName="Message" style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`annotation-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annotazione">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderStatoProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            iconContent = (
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`state-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annullato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderHasSummaryIAField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasSummaryIA) {
            iconContent = (
                <FontAwesomeIcon id={`summary-ia-${columnProps!.item!.id}`}
                    icon={{ prefix: 'fal', iconName: 'microchip-ai' }}
                    style={{ fontSize: 16, cursor: 'pointer' }}
                    onClick={() => this.openSummaryIACallout(columnProps!.item!)} />
            );

        }
        return (
            <div key={`wrap-summary-ia-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Analisi IA disponibile">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderVisibilitaField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.visibilita) {
            const arrayVisibilita = columnProps.item.visibilita;
            const visibilitaObj = arrayVisibilita.find(obj => obj.uor.id === this.props.currentUor!.id);
            let protocolId = columnProps.item.id;
            switch (visibilitaObj?.tipologia) {

                case Visibility_Type.Proprietario:
                    return (<TableIconProprietario key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.Inoltro:
                    return (<TableIconInoltro key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.CopiaConoscenza:
                    return (<TableIconCopiaConoscenza key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.Visibilita:
                    return (<TableIconVisibilita key={`visibilita-protocol-${protocolId}`} />);
                default:
                    return <div className={classNames.iconField} ></div>;

            }

        }
        return <div className={classNames.iconField} ></div>;
    }

    openSummaryIACallout = (item: IProtocol) => {
        const { location, match } = this.props;
        const aooId = Number(match.params['aooId']);
        const parsed = queryString.parse(location.search);
        const uorId = parsed.uorId ? Number(parsed.uorId) : undefined;

        const currentItem =
            this.state.items.find((el) => el && el.protocolId === item.protocolId) ?? item;

        this.setState({
            summaryIACalloutIsOpen: true,
            summaryIA: currentItem.summaryIA ?? undefined,
            summaryIAisLoading: !currentItem.summaryIA,
            summaryIACalloutTargetId: `summary-ia-${item.protocolId}`
        });

        if (currentItem.summaryIA || !currentItem.hasSummaryIA) return;

        this.setState({ summaryIAisLoading: true, summaryIA: undefined });
        protocolsService.getSummaryIA(aooId, uorId, item.protocolId!)
            .then(summaryIA => {
                this.setState((prev) => ({
                    summaryIA,
                    summaryIAisLoading: false,
                    items: prev.items.map((el) =>
                        el && el.protocolId === item.protocolId ? { ...el, summaryIA: summaryIA } : el
                    ),
                }));
            })
            .catch(error => {
                this.setState({
                    summaryIAisLoading: false
                });

                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere l'elaborazione IA`, life: 5000 });

                } else {
                    throw error;
                }

            });
    };

    dismissSummaryIACallout = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ summaryIACalloutIsOpen: false, summaryIACalloutTargetId: undefined, summaryIA: undefined })
    }

    onRenderDetailsHeader = (detailsHeaderProps) => {

        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {
            root: { boxSizing: 'content-box !important' }
        };

        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderItemColumn = (protocol?: IProtocolloAreaDiLavoro, index?: number | undefined, column?: IColumn): React.ReactNode => {
        let fieldName = column?.fieldName;

        if (!protocol || !fieldName) {
            return this.buildDefaultCellRenderData(this.EMPTY_VALUE);
        }

        // ------- Valori presi direttamente dall'oggetto IProtocolloAreaDiLavoro
        let displayValue;
        if (fieldName === "Protocollo") {
            return this.buildProtocolCellRenderData(protocol);
        }
        if (fieldName === "Priorita") {
            displayValue = protocol?.priorita ?? "-";
            return this.buildDefaultCellRenderData(displayValue);
        }
        if (fieldName === "PresaInCarico") {
            displayValue = AppUtilities.FieldFormatUserInternalValue(protocol?.presaInCarico, false);
            return this.buildDefaultCellRenderData(displayValue);
        }
        // ----------------------------------------------------------------------

        // ------- Valori presi dai fields di IProtocolloAreaDiLavoro
        const fieldValue = protocol.fields?.find(f => f.internalName === fieldName);
        if (!fieldValue) {
            return this.buildDefaultCellRenderData(this.EMPTY_VALUE);
        }
        const fieldForDisplay = {
            ...column,
            internalValue: fieldValue.internalValue
        } as IField;

        displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldForDisplay) || this.EMPTY_VALUE;
        return this.buildDefaultCellRenderData(displayValue);
        // ----------------------------------------------------------------------


    }

    buildDefaultCellRenderData = (value: string): React.ReactNode => {
        const tooltipProps = {
            content: value,
            styles: tooltipHostStyles,
            overflowMode: TooltipOverflowMode.Self
        };
        return (
            <TooltipHost {...tooltipProps}>
                {value}
            </TooltipHost>
        );
    };


    buildProtocolCellRenderData = (protocol: IProtocolloAreaDiLavoro): React.ReactNode => {
        let protocolText: string = AppUtilities.GetProtocolText(protocol);
        const tooltipProps = {
            content: protocolText,
            styles: tooltipHostStyles,
            overflowMode: TooltipOverflowMode.Self
        };
        let fontStyle = protocol?.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere ? { fontWeight: 'bolder', fontStyle: 'italic' } as React.CSSProperties : {};

        return (
            <TooltipHost {...tooltipProps}>
                <Link key={`link-protocol-${protocol.protocolId}`} style={{ ...fontStyle, width: "100%" }} onClick={(ev) => this.onClickProtocol(ev, protocol)} to={''}>
                    {protocolText}
                </Link>
            </TooltipHost>
        );
    }



    private removeNullPlaceholders = (items: (IProtocolloAreaDiLavoro | null)[]) =>
        items.filter((item): item is IProtocolloAreaDiLavoro => item !== null);



    public render() {
        let loaderClass = this.state.showActionsLoader ? "active" : '';
        return (
            <React.Fragment>
                <div className="workspace-component">
                    <div className={"loader opacity " + loaderClass}>
                        <RippleLoader text='Operazione in corso' />
                    </div>

                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                    <CommandBar
                        overflowButtonProps={overflowProps}
                        items={this.state.commandBarItems}
                        styles={commandBarStyles}

                    />

                    <div className={classNames.filtriCommandBar} >
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.filtriCommandBarItems}
                            farItems={this.state.filtriCommandBarFarItems}

                            styles={filtriCommandBarStyles}

                        />
                    </div>

                    {this.state.items.length > 0 &&
                        <DetailsList
                            className="with-empty-column"
                            styles={detailsListStyles}
                            componentRef={this.detailsListRef}
                            items={this.state.items}
                            columns={this.state.columns}
                            onColumnHeaderClick={this.onColumnHeaderClick}
                            onRenderItemColumn={this.onRenderItemColumn}
                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                            onRenderMissingItem={this.onRenderMissingItem}
                            layoutMode={DetailsListLayoutMode.justified}
                            selection={this.protocolSelection}
                            selectionPreservedOnEmptyClick={true}
                            selectionMode={SelectionMode.multiple}
                            checkboxVisibility={CheckboxVisibility.onHover}
                            onItemContextMenu={this.onShowContextualMenu}

                        />
                    }
                    {this.state.items.length === 0 && !this.state.isLoadingProtocols &&

                        <Text block style={{ padding: 25 }}>Non ci sono protocolli.</Text>
                    }

                    <Dialog
                        hidden={!this.state.confirmDialogIsOpen}
                        onDismiss={this.dismissConfirmDialog}
                        dialogContentProps={this.state.confirmDialogContentProps}
                        modalProps={this.state.confirmDialogModalProps}
                    >
                        {this.state.confirmDialogContentProps.children &&
                            this.state.confirmDialogContentProps.children
                        }


                        <DialogFooter>
                            <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                            <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                        </DialogFooter>

                    </Dialog>

                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />


                    <SearchPanel
                        isOpen={this.state.searchPanelIsOpen}
                        initialSearchFields={this.state.searchFormFields}
                        onDismiss={this.dismissSearchPanel}
                        onApply={this.submitSearchPanelHandler}
                    />

                    <SummaryIACallout
                        isOpen={this.state.summaryIACalloutIsOpen}
                        targetId={this.state.summaryIACalloutTargetId}
                        summaryIA={this.state.summaryIA}
                        isLoading={this.state.summaryIAisLoading}
                        onDismiss={this.dismissSummaryIACallout}
                    />

                </div>
            </React.Fragment>


        );
    }

}

export default connector(withRouter(AreaDiLavoroProtocolsTable));




